import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { JVCheck } from "../../shared/JVCheck";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Fetch } from "../../utilities/fetch";
import { TRole } from "./modal";
import { IPagePermission } from "../../hooks/useAuth";
import { EmptyList, TListState } from "../../shared/modal";
import { useToast } from "../../context/toastProvider";

interface Iprops {
    data: TRole,
    open: boolean,
    hideDialog: () => void
}

type TL = TListState<IPagePermission>;

export const PagePermissionForm = (props: Iprops) => {
    const [table, setTable] = useState(EmptyList as TL);
    const [submitting, setSubmitting] = useState(false);
    const { showToast } = useToast();

    const saveToDB = async () => {
        if (submitting) return;
        setSubmitting(true);
        const data: { pageId: number, permission: boolean }[]
            = table.data.map(item => ({
                pageId: item.id,
                permission: item.permission
            }));
        const response = await Fetch("UpdatePermissions",
            {
                method: 'POST', body: data, query: `roleId=${props.data.id}`,
                onError: (m) => showToast({ severity: 'error', detail: m })
            });
        if (response) {
            props.hideDialog();
        }
        setSubmitting(false);
    }

    const loadTableData = async () => {
        setTable(prev => ({ ...prev, loading: true }));
        const result = await Fetch("RolePermissions",
            { query: `roleId=${props.data.id}` });
        if (result) {
            setTable({ data: result.data, count: result.count, loading: false });
        }
    }

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    const onHide = () => {
        props.hideDialog();
    }

    const onCheckChange = (rowData: IPagePermission) => {
        if (!props.data.companyId) return;
        setTable(prevState => ({
            ...prevState,
            data: prevState.data.map(d =>
                d.id === rowData.id ? { ...d, permission: !d.permission } : d
            ),
            loading: false
        }));
    };

    const CheckBodyTemplate = (rowData: IPagePermission) => {
        return (
            <span onClick={() => onCheckChange(rowData)}>
                <JVCheck disabled={!props.data.companyId} name={rowData.id?.toString()} checked={rowData.permission}></JVCheck>
            </span>
        );
    };

    const footerTemplate = () => {
        if (!props.data.companyId) return null;
        return <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button className="p-button-sm my-1" label="SAVE" onClick={saveToDB} type="button" loading={submitting}></Button>
            <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide} disabled={submitting}></Button>
        </div>
    }

    const decideBg = (rowData: IPagePermission) => {
        if (rowData.isFeature) {
            return 'surface-300';
        } else {
            return '';
        }
    };

    const isAllChecked = table.data.length > 0 && table.data.every(x => x.permission);
    const toggleAll = () => {
        if (!props.data.companyId) return;
        const newValue = !isAllChecked;

        setTable(prev => ({
            ...prev,
            data: prev.data.map(d => ({
                ...d,
                permission: newValue
            }))
        }));
    };
    const HeaderCheckbox = () => {
        return (
            <span onClick={toggleAll} style={{ cursor: 'pointer' }}>
                <JVCheck disabled={!props.data.companyId} checked={isAllChecked} name="all" />
            </span>
        );
    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={<span style={{ fontWeight: '500', color: 'white', background: 'var(--gray-700)', padding: '1px 5px', borderRadius: '2px' }}>{props.data.name}</span>} footer={footerTemplate} className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={table.data} emptyMessage="Loading..." loading={table.loading} rowClassName={decideBg}>
                <Column field="name" header="Page/Feature" />
                <Column field="label" header="Label" />
                <Column field="description" header="Description" />
                <Column header={HeaderCheckbox} body={CheckBodyTemplate} headerStyle={{ width: '10%' }} />
            </DataTable>
        </Dialog>
    );
}
